const personnummer = require('personnummer.js');
const validatePersonalId = (data) => {
  if (!data) { return false; }
  const { personalId, physicalMemberCard, hasNoPersonalId, membershipActive } = data;

    /**
     * physicalMemberCard refers to a customer created through admin to use
     * a physical membership card, not mobile app.
     * It would make no sense to create customer for physical
     * membership card and not enter a personal ID.
     * **/
    if (
        personalId === ""
        &&
        (
        hasNoPersonalId 
        || (!membershipActive && !physicalMemberCard)
        )
    ) {
        return true
    }

    return personnummer.validate(personalId);
    // let pattern = /^[0-9]{10}$/;
    // return pattern.test(personalId);
};

export default validatePersonalId;